import { motion } from "framer-motion";

const STEPS = [
  { icon: "search", title: "Asset Discovery" },
  { icon: "hub", title: "Network Exposure" },
  { icon: "bug_report", title: "Web Vuln Detection" },
  { icon: "lock", title: "TLS/SSL Posture" },
  { icon: "smart_toy", title: "AI & LLM Surface" },
  { icon: "analytics", title: "Risk Scoring" },
  { icon: "description", title: "Evidence & Reporting" },
];

export default function WorkflowSection() {
  return (
    <section className="py-section-gap px-margin-mobile md:px-gutter max-w-container-max mx-auto bg-surface-container-low dark:bg-white/5 rounded-3xl">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.5 }}
        className="text-center mb-section-gap"
      >
        <p className="font-eyebrow text-eyebrow text-primary-container mb-stack-md uppercase tracking-widest">
          How It Works
        </p>
        <h2 className="font-headline-section text-headline-section text-on-surface dark:text-surface-bright">
          End-to-End Attack Surface Visibility
        </h2>
      </motion.div>

      <div className="relative">
        <div className="hidden lg:block absolute top-1/2 left-0 w-full h-0.5 bg-border-glass -translate-y-1/2 z-0 border-dashed border-t-2 border-surface-dim" />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 gap-stack-md relative z-10">
          {STEPS.map((step, i) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.4, delay: i * 0.06 }}
              className={`bg-surface-card-light dark:bg-surface-card-dark backdrop-blur-lg border border-glass rounded-xl p-6 text-center hover:-translate-y-1 transition-transform shadow-sm relative ${
                i === 5 ? "border-t-2 border-t-primary-container" : ""
              }`}
            >
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary-container text-white font-data-mono text-label-sm w-6 h-6 rounded-full flex items-center justify-center">
                {i + 1}
              </div>
              <span className="material-symbols-outlined text-primary-container mb-3 text-3xl block">
                {step.icon}
              </span>
              <h4 className="font-headline-card text-[16px] text-on-surface dark:text-surface-bright">
                {step.title}
              </h4>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
